import { call, put, takeLatest, throttle, debounce } from 'redux-saga/effects';
import * as _ from 'lodash';

import * as backofficeApi from '../services/api/backofficeApi';
import * as classroomApi from '../services/api/classroomApi';
import * as transformerService from '../services/cmi5/transformerService';
import { REDUCER } from '../reducers/reducersConst';
import { setFilteredBooks, setPaginator, removeSearchConfig } from '../actions/libraryActions';
import { setFetchingClassrooms, setActiveClassroomData, setClassroomInfo } from '../actions/classroom/classroomActions';
import { setInClassroom } from '../listeners/route/routeListener';
import { getLogger } from '../services/logger';
import { startConnection } from '../services/socketConnection/socketSubscriberService';
import { setCurrentDiscussions, setFinishedDiscussions, setFutureDiscussions } from '../actions/discussionActions';

const debug = getLogger('actions:sagasLibrary');

// worker Saga: will be fired on REDUCER.SAGAS.SET_FILTERED_BOOKS actions
export function* fetchBooks(action) {
  try {
    const payloadArray = [
      action.payload.institutionId,
      action.payload.metadataToSearch,
      action.payload.currentTags,
      action.payload.newPage,
      action.payload.maxPageSize,
      action.payload.currentPaginator
    ];
    const response = yield call(backofficeApi.getLibraryBooks, ...payloadArray);

    let books = transformerService.transformCMI5ToLibrary(response.data._embedded);
    yield put(setFilteredBooks(books));

    let paginatorParameters = [action.payload.currentPaginator, response.data._links, response.data.page];
    let newPaginator = transformerService.transformCMI5ToLibraryPaginator(...paginatorParameters);
    newPaginator.page = action.payload.newPage;

    yield put(setPaginator(newPaginator));
  } catch (err) {
    debug.error('[sagasLibrary] fetchBooks', err);
    yield put(removeSearchConfig());
  }
}

export function* fetchActiveClassrooms(action) {
  yield put(setFetchingClassrooms(true));
  try {
    const response = yield call(classroomApi.getActiveClassrooms, action.payload.userId);
    const classrooms = response.data;
    let classesArray = classrooms.map((classItem, index) => {
      classItem.position = index + 1;
      return classItem;
    });
    classesArray = _.uniqBy(classesArray, 'id');
    yield put(setActiveClassroomData(classesArray));
    yield put(setFetchingClassrooms(false));
    return classesArray;
  } catch (error) {
    debug.error('[sagasLibrary] fetchActiveClassrooms', error);
    yield put(setFetchingClassrooms(false));
    return error;
  }
}

export function* fetchCurrentClassroom(action) {
  try {
    const response = yield call(classroomApi.getClassroom, action.classroomId);

    if (response.data) {
      yield put(setClassroomInfo(response.data));
      yield put(setInClassroom(true));
      startConnection();
    }
    return response.data;
  } catch (err) {
    console.error(err);
    debug.error('[sagasLibrary] fetchCurrentClassroom', err);
    return err;
  }
}

export function* deleteDiscussionsOnChangeClassroom(action) {
  try {
    yield put(setCurrentDiscussions([]));
    yield put(setFinishedDiscussions([]));
    yield put(setFutureDiscussions([]));
  } catch (err) {
    console.error(err);
    debug.error('[sagasLibrary] deleteDiscussionsOnChangeClassroom', err);
    return err;
  }
}

function* mySaga() {
  yield takeLatest(REDUCER.LIBRARY.REQUEST_FILTERED_BOOKS, fetchBooks);
  yield debounce(100, REDUCER.CLASSROOM.FETCH_CURRENT_CLASSROOM, fetchCurrentClassroom);
  yield debounce(100, REDUCER.CLASSROOM.FETCH_CURRENT_CLASSROOM, deleteDiscussionsOnChangeClassroom);
  yield throttle(1000, REDUCER.CLASSROOM.FETCH_ACTIVE_CLASSROOMS, fetchActiveClassrooms);
}

export default mySaga;
